module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.upcoming) ? _c('section', {
    staticClass: "news"
  }, _vm._l((_vm.upcoming), function(event) {
    return _c('event', {
      attrs: {
        "e": event
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('section', {
    staticClass: "more"
  }, [_vm._v("\n    " + _vm._s(_vm.upcoming.length ? 'Ещё' : 'Никаких') + "\n    митапов не предвидится, но ты можешь\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'new'
      }
    }
  }, [_vm._v("организовать свой")]), _vm._v("\n    или попробовать\n    "), _c('a', {
    staticStyle: {
      "color": "#5fbc5f"
    },
    attrs: {
      "href": "https://stepik.org"
    }
  }, [_vm._v("пройти курс на степике")]), _vm._v(".\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.outdated) ? _c('section', {
    staticClass: "outdated"
  }, _vm._l((_vm.outdated), function(event) {
    return _c('event', {
      attrs: {
        "e": event,
        "no-time": true
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-173aec36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/main.vue
// module id = 155
// module chunks = 1